var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86603 1C4.48113 0.333334 3.51887 0.333333 3.13397 0.999999L0.535898 5.5C0.150998 6.16667 0.632122 7 1.40192 7L6.59807 7C7.36788 7 7.849 6.16667 7.4641 5.5L4.86603 1Z",
    fill: "#00D3C7",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon01);
export default __webpack_public_path__ + "static/media/sort-icon-01.ee0b533bf5b6b1791756cbf518dd06dd.svg";
export { ForwardRef as ReactComponent };